<!--
  由于slot模板内容即使没有slot出口，模板也会被渲染，而引起控制台报错，针对此类问题，可在插槽
  模板根元素上添加v-if="pageInit"来防止插槽模板提前渲染
 -->
<template>
  <div :class="[bem(), client, appVersion]">
    <v-header
      v-if="headerOption.show || headerOption.forceShow"
      :name="headerOption.name"
      :search="headerOption.search"
      :backShow="headerOption.backShow"
      :headerBg="headerOption.headerBg"
      :forceShow="headerOption.forceShow"
      :rightText="headerOption.rightText"
      :showMenuIcon="headerOption.showMenuIcon"
      @rightClick="handelRightClick"
    />
    <div v-if="isShowPageError" :class="bem('error')">
      <v-empty type="error">
        <div class="option btn-group">
          <nx-button @click="retry" type="frame-plus">点击重试</nx-button>
          <nx-button @click="returnHome" type="frame-plus">返回首页</nx-button>
        </div>
      </v-empty>
    </div>
    <div v-else :class="bem('container')" :style="contentStyle">
      <!--是否已经初始化完成-->
      <slot v-if="pageInit" />
      <!--初始化没有完成，显示等待状态，支持sketch-->
      <template v-else>
        <div v-if="skeleton" :class="bem('skeleton')">
          <slot name="skeleton" />
        </div>
        <v-pending v-else :class="[isLowAndroid ? 'lowAndroid' : '']" />
      </template>
    </div>
  </div>
</template>
<script>
import create from '../create'
import env from 'utils/clientEnv'
import { Button } from '@vivo/vos-ui'

export default create({
  name: 'page',
  components: {
    [Button.name]: Button
  },
  props: {
    // 是否错误页面
    pageError: {
      type: Boolean,
      default: false
    },
    // 是否完成初始化
    pageInit: {
      type: Boolean,
      default: false
    },
    pageTitle: {
      type: String,
      default: '很抱歉，服务器开小差了~'
    },
    // 头部配置
    header: {
      type: Object
    },
    // 是否自定义等待,比如骨架图
    skeleton: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLowAndroid: env.androidLevel && env.androidLevel < 8 && env.isVivoApp
    }
  },
  computed: {
    isShowPageError() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageError || this.pageError
    },
    errorTitle() {
      // 如果全局pageError状态为true，则直接显示错误页，否则，判断page组件pageError状态
      return this.$store.state.pageTitle || this.pageTitle
    },
    headerOption() {
      return Object.assign(
        {},
        {
          show: !env.isWx && !env.isQQ && !env.isAlipay && !env.isVHome,
          name: '',
          headerBg: ''
        },
        this.header
      )
    },
    contentStyle() {
      return this.bgColor ? 'background-color: ' + this.bgColor : ''
    },
    client() {
      var clientType = ''

      if (env.isWx) {
        clientType = 'wx'
      } else if (env.isAlipay) {
        clientType = 'alipay'
      } else if (env.isVivoApp) {
        clientType = 'vivoapp'
      } else if (env.isVHome) {
        clientType = 'vhome'
      } else if (env.isBankabc) {
        clientType = 'bankabc'
      }

      return clientType
    },
    appVersion() {
      if (!env.isVivoApp) return ''
      return `v-${env.appVersion}` || ''
    }
  },
  destroyed() {
    this.$osDialog.closeAll()
    this.$dialog.close()
  },
  methods: {
    retry() {
      location.reload()
    },
    returnHome() {
      location.href = `${this.linkBase}/index.html`
    },
    handelRightClick() {
      this.$emit('rightClick')
    }
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
